module.exports = __webpack_public_path__ + "img/dumpster-fire.11c5792c.svg";